import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Contact} from '../../class/contact';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  @Input()
  contacts: Contact[];
  @Input()
  editMode: boolean;

  @Output()
  onContactAdd = new EventEmitter<Contact[]>();

  constructor() {
  }

  ngOnInit(): void {
    this.initContacts();
  }

  getIconType(type: string) {
    switch (type) {
      case 'MOBILE_PHONE': {
        return 'smartphone-outline';
      }
      case 'PHONE': {
        return 'phone-outline';
      }
      case 'FAX': {
        return 'printer-outline';
      }
      case 'EMAIL': {
        return 'email-outline';
      }
    }
  }
  addRow(){
    this.initContacts();
    let contact =
    this.contacts.push({
      type: null,
      value: null
    })
    this.onContactAdd.emit(this.contacts)
  }
  private initContacts(){
    if(!this.contacts){
      this.contacts = [];
    }
  }
}
